/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-language.reducer';

export const DoctorLanguageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorLanguageEntity = useAppSelector(state => state.doctorLanguage.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorLanguageDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorLanguage.detail.title">DoctorLanguage</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorLanguage.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorLanguageEntity.id}</dd>
          <dt>
            <span id="fluency">
              <Translate contentKey="tinyMedicRestApp.doctorLanguage.fluency">Fluency</Translate>
            </span>
          </dt>
          <dd>{doctorLanguageEntity.fluency}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorLanguage.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorLanguageEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorLanguage.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorLanguageEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorLanguage.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorLanguageEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorLanguage.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorLanguageEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorLanguage.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorLanguageEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorLanguage.language">Language</Translate>
          </dt>
          <dd>{doctorLanguageEntity.language ? doctorLanguageEntity.language.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorLanguage.doctor">Doctor</Translate>
          </dt>
          <dd>{doctorLanguageEntity.doctor ? doctorLanguageEntity.doctor.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-language" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-language/${doctorLanguageEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorLanguageDetail;
